import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { apiGetCategorySelect } from '../../../actions/CategoryActions';
import { propBool, propNumber } from '../../../helpers/custom-prop-types';
import { useDidMount } from '../../../helpers/use/useHook';
import { AllLoaderComponent } from '../Loading';
const CategoryHoc = (apiCategoryType, reducerCategoryType) => (ChildComponent) => {
    const CategoryHocInner = (props) => {
        const dispatch = useDispatch();
        const categoryTypes = useSelector((state) => state.category[reducerCategoryType]);
        useDidMount(() => {
            dispatch(apiGetCategorySelect(apiCategoryType));
        });
        if (!categoryTypes) {
            return _jsx(AllLoaderComponent, {});
        }
        return _jsx(ChildComponent, Object.assign({}, props));
    };
    CategoryHocInner.propTypes = {};
    return CategoryHocInner;
};
CategoryHoc.propTypes = {
    isShow: propBool().isRequired,
    timeout: propNumber().isRequired,
};
export default CategoryHoc;
